import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    setPage,
    setSearchValue,
    setKeyword,
    setFilters,
    clearFilters,
    toggleActiveTab,
} from '../../store/promoSlice.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';

import PromotionOrderPanel from './paymentTest2'; // Upewnij się, że ścieżka jest poprawna

import './Promo.css'
import Table from "../../components/list2/table";
import { getHeaders, headerWidths } from "./promoHistoryTableConfig";
import TableFooter from '../../components/components/table_footer/TableFooter.jsx';
import FilterBar from '../../components/components/filter_bar/FilterBar.jsx';
import FilterPanel from '../../components/components/filter_panel/FilterPanel.jsx';
import { fetchPromotions, mapPromotionsToRows } from './promoTableService.js';
import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import PromoEventModal from './PromoEventModal.jsx';
import PageTabs from '../../components/components/page_tabs/PageTabs.jsx';

function Promo() {
    const dispatch = useDispatch();
    const checkedItems = useSelector((state) => state.promo.checkedItems);
    const sortBy = useSelector((state) => state.promo.sortBy);
    const sortDirection = useSelector((state) => state.promo.sortDirection);
    const currentPage = useSelector((state) => state.promo.currentPage);
    const totalPages = useSelector((state) => state.promo.maxPages);
    const totalCount = useSelector((state) => state.promo.totalCount);
    const searchValue = useSelector((state) => state.promo.searchValue);
    const keyword = useSelector((state) => state.promo.keyword);
    const filters = useSelector((state) => state.promo.filters);
    const activeTab = useSelector((state) => state.promo.activeTab);
    const sortArrowColorActive = '#060606';
    const sortArrowColorInactive = '#06060650';

    const [rawPromotions, setRawPromotions] = useState([]);

    const [isOrderPanelOpen, setIsOrderPanelOpen] = useState(false);
    const [selectedPlanType] = useState('Basic');
    const [isPromoModalOpen, setIsPromoModalOpen] = useState(false);
    const [promoModalData, setPromoModalData] = useState(null);
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

    const openPromoModal = (initialData = null) => {
        setPromoModalData(initialData);
        setIsPromoModalOpen(true);
    };

    const handleClosePromoModal = () => {
        setIsPromoModalOpen(false);
        setPromoModalData(null);
    };

    const handleSubmitPromoModal = (formData) => {
        console.log('Submit promotion:', formData);
        setIsPromoModalOpen(false);
        setPromoModalData(null);
    };

    const rows = useMemo(() => {
        return mapPromotionsToRows(rawPromotions, checkedItems, dispatch, {
            onRenew: (promo) => openPromoModal({
                categoryId: promo.categoryId,
                organizerId: promo.organizerId,
                eventId: promo.eventId,
                promotionType: promo.promotionType,
                startDate: promo.date,
            }),
            onPromote: (promo) => openPromoModal({
                categoryId: promo.categoryId,
                organizerId: promo.organizerId,
                eventId: promo.eventId,
            }),
            onDelete: (promo) => {
                console.log('Delete promo:', promo.id);
            },
        });
    }, [rawPromotions, checkedItems, dispatch]);

    useEffect(() => {
        fetchPromotions(currentPage, sortBy, sortDirection, keyword, filters, dispatch, setRawPromotions);
    }, [currentPage, sortBy, sortDirection, keyword, filters, dispatch]);

    const headers = getHeaders(
        sortBy,
        sortDirection,
        dispatch,
        sortArrowColorActive,
        sortArrowColorInactive,
        rawPromotions,
        checkedItems,
    );

    const handlePageChange = (page) => {
        dispatch(setPage(page));
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        dispatch(setSearchValue(value));
        if (value.length >= 3) {
            dispatch(setKeyword(value));
        } else {
            dispatch(setKeyword(null));
        }
    };

    const handleFilterClick = () => {
        setIsFilterPanelOpen(true);
    };

    const handleCloseFilterPanel = () => {
        setIsFilterPanelOpen(false);
    };

    const handleApplyFilters = (newFilters) => {
        dispatch(setFilters(newFilters));
        setIsFilterPanelOpen(false);
    };

    const handleClearFilters = () => {
        dispatch(clearFilters());
    };

    const handleRemoveFilter = (filterKey) => {
        const newFilters = { ...filters, [filterKey]: '' };
        dispatch(setFilters(newFilters));
    };

    const handleDeleteSelected = () => {
        if (checkedItems.length === 0) {
            alert('Nie wybrano żadnych wpisów do usunięcia');
            return;
        }
        if (window.confirm(`Czy na pewno chcesz usunąć ${checkedItems.length} wpisów?`)) {
            console.log('Delete promotions:', checkedItems);
            alert('Funkcja usuwania w trakcie implementacji');
        }
    };

    const handleTabChange = (tabId) => {
        dispatch(toggleActiveTab(tabId));
    };

    const getActiveFilterCount = () => (
        Object.values(filters).filter((v) => v && v !== '').length
    );

    const filterChips = [];
    if (filters.dateFrom) {
        filterChips.push({ key: 'dateFrom', label: `Od: ${filters.dateFrom}`, value: filters.dateFrom });
    }
    if (filters.dateTo) {
        filterChips.push({ key: 'dateTo', label: `Do: ${filters.dateTo}`, value: filters.dateTo });
    }
    if (filters.organizerId) {
        const organizerLabels = {
            fest: "Festiwal'25",
            masters: 'Event Masters',
            'org-1': 'Organizator 1',
            'org-2': 'Organizator 2',
        };
        filterChips.push({
            key: 'organizerId',
            label: organizerLabels[filters.organizerId] || filters.organizerId,
            value: filters.organizerId
        });
    }
    if (filters.promotionType) {
        filterChips.push({ key: 'promotionType', label: filters.promotionType, value: filters.promotionType });
    }
    if (filters.status) {
        const statusLabels = { active: 'trwa', finished: 'zakończono' };
        filterChips.push({ key: 'status', label: statusLabels[filters.status] || filters.status, value: filters.status });
    }

    const promoFilterFields = [
        [
            { key: 'dateFrom', label: 'Data', type: 'date' },
            { key: 'dateTo', label: 'Data zakończenia', type: 'date' }
        ],
        [
            { key: 'organizerId', label: 'Organizator', type: 'select', optionsKey: 'organizers', placeholder: 'Wybierz' },
            { key: 'promotionType', label: 'Rodzaj promowania', type: 'select', optionsKey: 'promotionTypes', placeholder: 'Wybierz' }
        ],
        [
            { key: 'status', label: 'Status', type: 'select', optionsKey: 'status', placeholder: 'Wszystkie' }
        ]
    ];

    const promoFilterOptions = {
        organizers: [
            { value: '', label: 'Wybierz' },
            { value: 'fest', label: "Festiwal'25" },
            { value: 'masters', label: 'Event Masters' },
            { value: 'org-1', label: 'Organizator 1' },
            { value: 'org-2', label: 'Organizator 2' }
        ],
        promotionTypes: [
            { value: '', label: 'Wybierz' },
            { value: 'Basic', label: 'Basic' },
            { value: 'Standard', label: 'Standard' },
            { value: 'Visibility+', label: 'Visibility+' },
            { value: 'Premium', label: 'Premium' }
        ],
        status: [
            { value: '', label: 'Wszystkie' },
            { value: 'active', label: 'trwa' },
            { value: 'finished', label: 'zakończono' }
        ]
    };

    const promoTabs = [
        { id: 'promo', label: 'Promowanie', count: totalCount }
    ];


    return (
    <div>
      <Menu />
      <Content>
        {isOrderPanelOpen ? (
          <PromotionOrderPanel
              initialPlan={selectedPlanType}
              onBack={() => setIsOrderPanelOpen(false)}
          />
        ) : (
        <div className="promo-page">
          <div className="promo-header">
            <div className="promo-tabs-row">
                <PageTabs
                    tabs={promoTabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
                <button className="promo-add-button" onClick={() => openPromoModal()}>
                    <AddIcon className="promo-add-icon" />
                    Promuj wydarzenie
                </button>
            </div>
          </div>

          <div className="table-container promo-table-container">
            <FilterBar
                filters={filters}
                filterChips={filterChips}
                searchValue={searchValue}
                onSearchChange={handleSearchChange}
                resultsCount={totalCount}
                showFilterButton
                showResultsCount
                onFilterClick={handleFilterClick}
                onClearFilters={handleClearFilters}
                onRemoveFilter={handleRemoveFilter}
                activeFilterCount={getActiveFilterCount()}
            />

            <Table
                headers={headers}
                rows={rows}
                columnWidths={headerWidths}
                cellClass2="cell-center"
                cellClass2ConditionList={[1, 2, 6, 7, 8]}
                tableClass="promo-table"
            />

            <TableFooter
                checkedItems={checkedItems}
                onDeleteSelected={handleDeleteSelected}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                maxVisibleButtons={4}
            />
          </div>
        </div>)}
        <FilterPanel
            isOpen={isFilterPanelOpen}
            onClose={handleCloseFilterPanel}
            onApplyFilters={handleApplyFilters}
            fields={promoFilterFields}
            options={promoFilterOptions}
        />
        <PromoEventModal
            isOpen={isPromoModalOpen}
            onClose={handleClosePromoModal}
            onSubmit={handleSubmitPromoModal}
            initialData={promoModalData}
        />
      </Content>
    </div>
  );
}

export default Promo;
